/* eslint-disable default-param-last */
import SiteRegistrationState from 'models/siteRegistration';
import { SITEREGISTRATION_ACTIONS } from 'actions/siteregistration';

const SiteRegistrationReducer = (state = SiteRegistrationState, action) => {
  switch (action.type) {
    case SITEREGISTRATION_ACTIONS.SET_REGISTRATION_DETAILS:
      return {
        ...state,
        registrationDetails: action.payload
      };
    case SITEREGISTRATION_ACTIONS.SET_REGISTRATION_STATUS_HISTORY:
      return {
        ...state,
        statusHistory: action.payload
      };
    default:
      return state;
  }
};

export default SiteRegistrationReducer;
